module.exports = __webpack_public_path__ + "static/media/icon-label--recommended.5521063c.svg";